module.exports = __webpack_public_path__ + "img/propositions-en-attentes.85fda0d3.svg";